
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import HeadModule from '../components/Modules/HeadModule';
import GenericHeader from '../components/Modules/GenericHeader';
import UserSubscription from '../components/User/UserSubscription';
import useTranslation from 'next-translate/useTranslation';
import { FREE_PLAN } from '../constants/plans';
import { VStack } from '@chakra-ui/react';
const Pricing = () => {
    const { t } = useTranslation();
    return (<VStack spacing={12}>
      <HeadModule title='meta_title_home' description='meta_description_profile'/>
      <GenericHeader title={t('menu:header_menu_pricing')}/>
      <UserSubscription currentPlan={FREE_PLAN}/>
    </VStack>);
};
export default Pricing;

    async function __Next_Translate__getStaticProps__196fbffbb0e__(ctx) {
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/pricing',
            loaderName: 'getStaticProps',
            loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__196fbffbb0e__ as getStaticProps }
  